import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEqual } from 'lodash';
import { Dropdown, Nav } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import { backgroundGrey3, deeplavender, greyscale } from 'lib/css/colors';
import { NAVIGATION_SIDE_BAR_WIDTH } from 'lib/constants';
import NestedDropdownItem from 'components/layout/sidenav/NestedDropdownItem';
import useUserPermissions from 'lib/hooks/useUserPermissions';

function SideNavItemWithChildren({ title, icon, submenuItems }) {
  const hasUserPermissions = useUserPermissions();

  const loc = useLocation();
  const isActive = submenuItems.some(item => {
    if (isEqual(loc.pathname, item.url)) return true;
    // Check child URLs too
    if (item.children && item.children.some(child => isEqual(loc.pathname, child.url))) return true;
    return false;
  });

  return (
    <Dropdown drop="right">
      <Dropdown.Toggle
        as={Nav.Link}
        className={classNames(css(styles.link, isActive && styles.currentIcon))}
      >
        <div className={css(styles.iconContainer)}>
          <FontAwesomeIcon size="lg" icon={icon} />
          <div className={css(styles.textWrapper)}>{title}</div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className={css(styles.dropdownMenu)}>
        {submenuItems.map((submenuItem, index) => (
          <NestedDropdownItem key={index} item={submenuItem} index={index} />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  currentIcon: {
    color: deeplavender,
    backgroundColor: backgroundGrey3,
  },
  dropdownMenu: {
    padding: '0rem',
    minWidth: '6.4rem',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  link: {
    '::after': {
      display: 'none',
    },
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.5rem',
    color: greyscale,
    maxWidth: NAVIGATION_SIDE_BAR_WIDTH - 4,
  },
  textWrapper: {
    fontSize: '10px',
  },
});

SideNavItemWithChildren.propTypes = {
  submenuItems: PropTypes.array,
  title: PropTypes.string,
  icon: PropTypes.object,
};

export default SideNavItemWithChildren;
